<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P0003600.filtration.controle.mode' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3">
    <app-mode-control-multiple
      [datas]="getButtons()"
      [value]="this.actionStack!.getValue('fvsCModeFonctionnement')"
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.FiltrationVS_Controle,
          'fvsCModeFonctionnement',
          $event
        );
        this.actionStack!.commit()
      "
    >
    </app-mode-control-multiple>
  </div>
</div>

<div class="my-2 mb-4">
  <div class="row align-items-center">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P0003600.filtration.controle.programme' | translate
      }}</ion-label>
    </div>
    <div class="col-auto">
      <div class="p-2 pointer-hover" (click)="openenSavoirPlus()">
        <i class="fa-regular fa-info-circle color-primary"></i>
      </div>
    </div>
  </div>
  <div class="my-3">
    <div class="row justify-content-center align-items-center">
      <div class="col-4 mb-3">
        <div
          class="programme-button pointer-hover color-medium"
          (click)="
            this.actionStack!.editValue(
              P00039DataRxTxIndex.FiltrationVS_Controle,
              'fvsCProgrammeFiltrationAuto',
              0
            );
            this.actionStack!.commit()
          "
        >
          <div class="row h-100 align-items-center">
            <div
              class="col text-center"
              [class.color-orange]="
                actionStack!.getValue('fvsCProgrammeFiltrationAuto') === 0
              "
            >
              <div>
                <i class="fa-kit fa-picto-horloge72h fs-36"></i>
              </div>
              <div class="text-uppercase">
                {{
                  (actionStack!.getValue('fvsCProgrammeFiltrationAuto') === 0
                    ? convertSecondsToTime(
                        actionStack!.getValue('fvsSCompteAReboursSeconde72h')
                      )
                    : 'P0003601.filtration.controle.prog72H'
                  ) | translate
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-4 mb-3">
        <div
          class="programme-button pointer-hover color-medium"
          (click)="
            this.actionStack!.editValue(
              P00039DataRxTxIndex.FiltrationVS_Controle,
              'fvsCProgrammeFiltrationAuto',
              1
            );
            this.actionStack!.commit()
          "
        >
          <div class="row h-100 align-items-center">
            <div
              class="col text-center"
              [class.color-orange]="
                actionStack!.getValue('fvsCProgrammeFiltrationAuto') === 1
              "
            >
              <div>
                <i class="fa-kit fa-picto-horlogehiver fs-36"></i>
              </div>
              <div class="text-uppercase">
                {{ 'P0003601.filtration.controle.hiver' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-4 mb-3">
        <div
          class="programme-button pointer-hover color-medium"
          (click)="
            this.actionStack!.editValue(
              P00039DataRxTxIndex.FiltrationVS_Controle,
              'fvsCProgrammeFiltrationAuto',
              2
            );
            this.actionStack!.commit()
          "
        >
          <div class="row h-100 align-items-center">
            <div
              class="col text-center"
              [class.color-orange]="
                actionStack!.getValue('fvsCProgrammeFiltrationAuto') === 2
              "
            >
              <div>
                <i class="fa-kit fa-picto-horlogeete fs-36"></i>
              </div>
              <div class="text-uppercase">
                {{ 'P0003601.filtration.controle.ete' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
